// Inset ink preserves the exact time range and height, including subpixel bars.
export const PRINT_BAR_OUTLINE = 'inset 0 0 0 1px #000'
